import styled from '@emotion/styled';
import setMargin from './../../helpers/set-margin';

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -${({ inner, theme }) => (inner ? theme.constants.gridGutter.desktop / 2 : 0)}px !important;
  margin-right: -${({ inner, theme }) => (inner ? theme.constants.gridGutter.desktop / 2 : 0)}px !important;
  width: ${({ inner, theme }) =>
    inner ? `calc(100% + ${theme.constants.gridGutter.desktop}px)` : '100%'};
  justify-content: ${({ jc }) => jc || 'flex-start'};
  justify-content: ${({ jc }) => jc || 'flex-start'};
  margin-top: ${({ mt, theme }) => theme.spacings[mt] || '0'};
  margin-bottom: ${({ mb, theme }) => theme.spacings[mb] || '0'};
  align-items: ${({ ai }) => ai || 'flex-start'};

  ${({ theme }) => theme.media.tablet} {
    justify-content: ${({ jcT, jc }) => jcT || jc || 'flex-start'};
    margin-top: ${({ mt, mtT, theme }) =>
      theme.spacings[mtT] || theme.spacings[mt] || '0'};
    margin-bottom: ${({ mb, mbT, theme }) =>
      theme.spacings[mbT] || theme.spacings[mb] || '0'};
    margin-left: -${({ inner, theme }) => (inner ? theme.constants.gridGutter.tablet / 2 : 0)}px !important;
    margin-right: -${({ inner, theme }) => (inner ? theme.constants.gridGutter.tablet / 2 : 0)}px !important;
    width: ${({ inner, theme }) =>
      inner ? `calc(100% + ${theme.constants.gridGutter.tablet}px)` : '100%'};
  }
  ${({ theme }) => theme.media.mobile} {
    justify-content: ${({ jcM, jcT, jc }) => jcM || jcT || jc || 'flex-start'};
    margin-top: ${({ mt, mtM, theme }) =>
      theme.spacings[mtM] || theme.spacings[mt] || '0'};
    margin-bottom: ${({ mb, mbM, theme }) =>
      theme.spacings[mbM] || theme.spacings[mb] || '0'};
    margin-left: -${({ inner, theme }) => (inner ? theme.constants.gridGutter.mobile / 2 : 0)}px !important;
    margin-right: -${({ inner, theme }) => (inner ? theme.constants.gridGutter.mobile / 2 : 0)}px !important;
    width: ${({ inner, theme }) =>
      inner ? `calc(100% + ${theme.constants.gridGutter.mobile}px)` : '100%'};
  }
`;

export const Col = styled('div')`
  ${setMargin};
  box-sizing: border-box;
  padding-left: ${({ theme }) => `${theme.constants.gridGutter.desktop / 2}px`};
  padding-right: ${({ theme }) =>
    `${theme.constants.gridGutter.desktop / 2}px`};
  flex-shrink: 0;
  position: relative;
  width: 100%;
  min-height: 1;
  text-align: ${({ ta }) => ta || 'left'};
  
  flex-basis: ${({ theme, c3 }) =>
    `calc(${(c3 / theme.constants.columns.desktop) * 100}%)`};
  max-width: ${({ theme, c3 }) =>
    `calc(${(c3 / theme.constants.columns.desktop) * 100}%)`};
  display: ${({ theme, c3 }) => (c3 ? 'block' : 'none')};

  ${({ theme }) => theme.media.tablet} {
    padding-left: ${({ theme }) =>
      `${theme.constants.gridGutter.tablet / 2}px`};
    padding-right: ${({ theme }) =>
      `${theme.constants.gridGutter.tablet / 2}px`};
    display: ${({ theme, c2 }) => (c2 ? 'block' : 'none')};
    flex-basis: ${({ theme, c2 }) =>
      `calc(${(c2 / theme.constants.columns.tablet) * 100}%)`};
    max-width: ${({ theme, c2 }) =>
      `calc(${(c2 / theme.constants.columns.tablet) * 100}%)`};
    margin-top: ${({ mtT, mt, theme }) =>
      mtT ? theme.spacings[mtT] : theme.spacings[mt] || '0'};
    margin-bottom: ${({ mbT, mb, theme }) =>
      mbT ? theme.spacings[mbT] : theme.spacings[mb] || '0'};
  }

  ${({ theme }) => theme.media.mobile} {
    display: ${({ theme, c1 }) => (c1 ? 'block' : 'none')};
    flex-basis: ${({ theme, c1 }) =>
      `calc(${(c1 / theme.constants.columns.mobile) * 100}%)`};
    max-width: ${({ theme, c1 }) =>
      `calc(${(c1 / theme.constants.columns.mobile) * 100}%)`};
    margin-top: ${({ mtM, mtT, mt, theme }) => {
      if (mtM) {
        return theme.spacings[mtM];
      } else if (mtT) {
        return theme.spacings[mtT];
      } else {
        return theme.spacings[mt] || '0';
      }
    }};
    margin-bottom: ${({ mbM, mbT, mb, theme }) => {
      if (mbM) {
        return theme.spacings[mbM];
      } else if (mbT) {
        return theme.spacings[mbT];
      } else {
        return theme.spacings[mb] || '0';
      }
    }};
`;
